import React, { memo } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { makeSelectPaymentRequest, makeSelectOrder } from "ducks/selectors";

import SmartRender from "containers/SmartRender";

const PaymentQR = Component =>
  function Comp(props) {
    return <Component {...props} />;
  };

const mapStateToProps = createStructuredSelector({
  paymentRequest: makeSelectPaymentRequest(),
  order: makeSelectOrder()
});

const mapDispatchToProps = {};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect, memo)(PaymentQR(SmartRender));
